import { getSelectionText } from '../../services/utils'
import { trimResultTag } from '../../services/tagsParser'
import {
    getKeyboardShortcuts,
    updateContextMenu,
} from '../../background/services'
import { RECORD_MENU, SEARCH_MENU } from '../../background/constants'

export const updateContextMenuContent = () => {
    document.addEventListener('selectionchange', () => {
        const selection = getSelectionText()
        const tag = trimResultTag(selection)

        getKeyboardShortcuts(commands => {
            const recordShortcut = commands.find(
                c => c.name === RECORD_MENU
            )?.shortcut
            updateContextMenu({
                contextMenus: [RECORD_MENU],
                updateProps: {
                    title: `Start/Stop recording${
                        tag ? ` with tag #${tag}` : ''
                    }${recordShortcut ? ` (${recordShortcut})` : ''}`,
                },
            })

            const searchShortcut = commands.find(
                c => c.name === SEARCH_MENU
            )?.shortcut
            updateContextMenu({
                contextMenus: [SEARCH_MENU],
                updateProps: {
                    title: `Search for video${
                        selection ? ` "${selection}"` : ''
                    }${searchShortcut ? ` (${searchShortcut})` : ''}`,
                },
            })
        })
    })
}
